import { Img } from "react-image";
import React from "react";
import assetPath from "../../../utils/assets";
interface IconProps {
  iconName: string;
  id?: string;
  name?: string;
  width: number;
  height: number;
  className?: string;
}

const Icon: React.FC<IconProps> = ({
  iconName,
  name,
  width,
  height,
  className,
}) => {
  return (
    <Img
      alt=""
      id={name}
      src={assetPath(`${iconName}.svg`)}
      width={width}
      height={height}
      className={className}
    />
  );
};

export default Icon;
// usage
{
  /* <Icon iconName='Menu' height='30px' width='30px' ></Icon> */
}
